import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { device } from "../styles/global";
import { contacts } from "../library/contact-info";

const StyledFooter = styled.footer`
  background-color: var(--black);
  color: var(--white);
  padding-top: 3.62rem;

  .width-wrapper {
    display: flex;
    flex-direction: column;
    gap: 3.62rem;
  }

  a {
    width: fit-content;
  }

  .content {
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: 3rem;
  }

  .info {
    max-width: 23.125rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2rem;

    svg {
      color: var(--teal);
      width: 1.25rem;
      height: 1.25rem;
    }
  }

  .learn-more {
    text-decoration: underline;
    text-underline-offset: 25%;
  }

  ul.contacts {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;

    li {
      display: flex;
      gap: 1.15rem;
      align-items: center;
      max-width: 20rem;
    }
  }

  .copyright {
    display: flex;
    justify-content: center;
    padding: 3rem 0;
    border-top: 2px solid var(--teal);
    text-align: center;
  }

  @media ${device.tablet} {
    .content {
      flex-direction: column;
    }
  }
`;

const Footer = () => {
  return (
    <StyledFooter>
      <div className="width-wrapper">
        <div className="content">
          <div className="info">
            <p className="heading-xs poppins-700">About Us</p>
            <p>
              Renata Bliumaite – EA, NTPIF Renata Bliumaite established her
              Elmhurst, Illinois local tax practice in 2005 after retiring from
              Ostrow Reisin Berk & Abrams LTD.
            </p>
            <Link to="/about/" className="learn-more">
              Learn more
            </Link>
          </div>
          <div className="info">
            <p className="heading-xs poppins-700">Contact Info</p>
            <ul className="contacts">
              {contacts.map((contact) => (
                <li key={contact.title}>
                  <span className="icon">{contact.icon}</span>
                  {contact.text}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="copyright">
          © Copyright 2005 Qtatax. All Rights Reserved.
        </div>
      </div>
    </StyledFooter>
  );
};

export default Footer;
